// extracted by mini-css-extract-plugin
export var container = "_1l-0";
export var disabled = "_1l-4";
export var fullWidth = "_1l-3";
export var lined = "_1l-1";
export var selected = "_1l-5";
export var tab = "_1l-2";